import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, SITE } from "@/data/site";
import { SectionHead, Reveal } from "@/components/common/Reveal";

export const Faq = ({ index = "06" }) => (
  <section id="faq" className="bg-[#f8fafc] py-24 lg:py-32" data-testid="faq-section">
    <div className="container-q grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHead index={index} label="FAQ" title="Questions businesses often ask." />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-slate-600">
            Something else on your mind? Write to <a href={`mailto:${SITE.email}`} className="font-semibold text-slate-950 underline decoration-blue-600/40 underline-offset-4 hover:decoration-blue-600" data-testid="faq-email-link">{SITE.email}</a>.
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-slate-200">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-slate-200" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 text-left text-[17px] font-bold tracking-tight text-slate-950 hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="pb-6 pr-8 text-[15px] leading-relaxed text-slate-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
